import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Plugins
import { provideNzConfig } from 'ng-zorro-antd/core/config';
// Modules
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgChartsModule } from 'ng2-charts';
import { NgxCsvParserModule } from 'ngx-csv-parser';
import { ExportAsModule } from 'ngx-export-as';
import { AntdModule } from '@shared/antd.module';
// Pipes
import { ReplacePipe } from '@pipes/replace/replace.pipe';
// Components
import { UsersSelectComponent } from '@components/users-select/users-select.component';
import { AccountsSelectComponent } from '@components/accounts-select/accounts-select.component';
import { TableSearchComponent } from '@components/table-search/table-search.component';
import { ResetPasswordModalComponent } from '@components/reset-password-modal/reset-password-modal.component';
import { AllUsersSelectComponent } from '@components/all-users-select/all-users-select.component';

const COMPONENTS: Array<object> = [
	UsersSelectComponent,
	AccountsSelectComponent,
	TableSearchComponent,
	ResetPasswordModalComponent,
	AllUsersSelectComponent
];

const PIPES: Array<object> = [
	ReplacePipe
];

const MODULES: Array<object> = [
	FormsModule,
	ReactiveFormsModule,
	ClipboardModule,
	DragDropModule,
	ScrollingModule,
	NgChartsModule,
	NgxCsvParserModule,
	ExportAsModule,
	AntdModule,
];

@NgModule({
	declarations: [
		COMPONENTS,
		PIPES
	],
	imports: [
		CommonModule,
		MODULES
	],
	exports: [
		COMPONENTS,
		PIPES,
		MODULES,
		FormsModule,
	],
	providers: [
		provideNzConfig({ message: { nzMaxStack: 3 } })
	],
})
export class SharedModule { }